import React, { useState, useContext, useEffect } from 'react'
import Service from '../../../services/videos';
import Item from '../../../components/videos/item';
import { ContextUI } from '../../../uiContext';
import { Context } from '../../../AppContext';
import { Button, Paper, Tabs } from '../../../components/ui/core';

import MainMenu from '../../../components/mainmenu';
import Footer from '../../../components/mainfooter';

export default function VideoItem(props) {
    const contextUI = useContext(ContextUI);
    const context = useContext(Context);
    const [selectedTab, setSelectedTab] = useState(0)
    const [item, setItem] = useState();

    //INITIAL FUNCTIONS
    useEffect(() => {
        getItem();
        contextUI.setSubTitle('Videos ');
        contextUI.setShowBackButton(true);
        contextUI.setHeaderActions();
    }, [])

    useEffect(() => {


    }, [item])
    const getItem = () => { Service.get(props.match.params.id).then(item => setItem(item)).catch(err => { console.log(err) }) }

    const handleSave = (item) => { Service.update(item).then(result => { }).catch(ex => { console.log(ex) }) }
    const handleChange = (item) => { setItem(item) }

    if (!context.hasRights(context.user, 'fullcontrol-videos', 'w')) return null;


    return (<>
        <MainMenu history={props.history} />
        <div className='contentspacing'>
            <Button onClick={() => { props.history.goBack() }} variant="text" fullWidth> &lt; TERUG NAAR OVERZICHT VIDEO'S</Button>

            <Item item={item} onChange={handleChange} onSave={handleSave} canDelete={true} />
        </div>
        <Footer />
    </>)
}
